import { call, takeEvery } from 'redux-saga/effects';
import listener from '@/layout/goldenLayoutListener';
import urls, { codeUrl, collectionUrl } from '@/constants/urls';
import actions from '../constants';

export function* closeTab({ items }) {
  const itemsWithUrls = items.map((item) => collectionUrl(item));

  yield call(listener.closeTab, itemsWithUrls);
}

export function* navigateToNewCollection({ result, code }) {
  yield call(listener.navigate, {
    type: actions.NEW_COLLECTION,
    code: result.code,
    previousUrl: codeUrl(urls.COLLECTION, code),
    name: result.name,
    description: result.description,
    url: collectionUrl(result),
  });
}

export default function* collectionsLayout() {
  yield takeEvery(actions.DESTROY_COLLECTION, closeTab);
  yield takeEvery(actions.NEW_COLLECTION, navigateToNewCollection);
}
